import { createColumnHelper } from "@tanstack/react-table";
const columnHelper = createColumnHelper();

export const advertisementTableColumnsConfig = {
  advertisement: (handleNavigateToDetail) => [
    columnHelper.accessor("id", {
      header: "Id",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("categoryLabel", {
      header: "Category",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("page", {
      header: "Page",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),

    columnHelper.display({
      id: "actions",
      header: <div style={{ textAlign: "center" }}>Action</div>,
      cell: (props) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            style={{
              padding: "6px 12px",
              background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
              color: "#FFFFFF",
              fontWeight: 500,
              fontSize: "13px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(47,53,103,0.35)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(47,53,103,0.3)";
            }}
            onClick={() => handleNavigateToDetail(props.row.original)}
          >
            View Details
          </button>
        </div>
      ),
    }),
  ],
};
